import { Spinner } from "./Spinner";

export function PageLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-seaMist text-textBody">
      <Spinner size={40} className="text-oceanBlue" label="A carregar página" />
      <p className="mt-4 text-sm text-textMuted">A carregar...</p>
    </div>
  );
}
